import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { adminApi } from '../../services/api';
import { useNotifications } from '../../hooks/useNotifications';

const DeleteUnverifiedUsers: React.FC = () => {
  const notifications = useNotifications();
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const handleDeleteUnverifiedUsers = async () => {
    if (!window.confirm('Delete all unverified users? This action cannot be undone.')) {
      return;
    }

    setIsLoading(true);
    setMessage(null);

    try {
      const response = await adminApi.deleteUnverifiedUsers();
      setMessage(response.message);
      notifications.success(response.message || 'Unverified users were deleted.');
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || 'Failed to delete unverified users.';
      notifications.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="enterprise-card p-5">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-red-100 text-red-700 flex items-center justify-center flex-shrink-0">
          <AlertTriangle size={18} />
        </div>
        <div className="flex-1">
          <h4 className="text-sm font-semibold text-fintech-text mb-1">Delete Unverified Users</h4>
          <p className="text-xs text-fintech-textMuted mb-4">
            Permanently remove users that have not completed email verification.
          </p>
          <button
            onClick={handleDeleteUnverifiedUsers}
            disabled={isLoading}
            className="btn-danger"
          >
            {isLoading ? 'Deleting...' : 'Delete Unverified Users'}
          </button>
          {message && <p className="text-xs text-emerald-700 mt-3">{message}</p>}
        </div>
      </div>
    </div>
  );
};

export default DeleteUnverifiedUsers;
